import {QueueNameCd} from '../';
import {EnumHelper} from './enum-helper';

export class QueueNameCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in QueueNameCd ) {
      this._values.push(QueueNameCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): QueueNameCd {

    for ( const obj in QueueNameCd ) {
      if (QueueNameCd[obj] === value){
        return QueueNameCd[obj] as QueueNameCd;
      }
    }
  }
}

const QueueNameCdHelper = new QueueNameCdHelperEnumHelperClass();
export default QueueNameCdHelper;
